"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GET_CAROUSEL_PRODUCTS", {
  enumerable: true,
  get: function get() {
    return _getCarouselProducts.default;
  }
});
Object.defineProperty(exports, "GET_CUSTOMER_WISHLIST", {
  enumerable: true,
  get: function get() {
    return _getCustomerWishlist.default;
  }
});
Object.defineProperty(exports, "ADD_FAVORITE_ITEM_MUTATION", {
  enumerable: true,
  get: function get() {
    return _addFavoriteItem.default;
  }
});
Object.defineProperty(exports, "REMOVE_FAVORITE_ITEM_MUTATION", {
  enumerable: true,
  get: function get() {
    return _removeFavoriteItem.default;
  }
});

var _getCarouselProducts = _interopRequireDefault(require("./get-carousel-products"));

var _getCustomerWishlist = _interopRequireDefault(require("./get-customer-wishlist"));

var _addFavoriteItem = _interopRequireDefault(require("./add-favorite-item"));

var _removeFavoriteItem = _interopRequireDefault(require("./remove-favorite-item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }